import { render, staticRenderFns } from "./OpeningHours.vue?vue&type=template&id=be3dcaf0&scoped=true&"
import script from "./OpeningHours.vue?vue&type=script&lang=ts&"
export * from "./OpeningHours.vue?vue&type=script&lang=ts&"
import style0 from "./OpeningHours.vue?vue&type=style&index=0&id=be3dcaf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3dcaf0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanels,VIcon})
